<script>
    // Stores
    import { 
        // linkInstagram, 
        // linkYoutube, 
        linkTwitter,
        linkInstagram,
        linkFacebook, 
        linkMapa, 
        linkWaze, 
        linkUber, 
        linkAV, 
        linkAPI, 
        linkWhatsappVendas, 
        linkWhatsappLocacao, 
        linkWhatsappBoletos, 
        linkTelefone,
        tagsSEO, 
        textEndereco, 
        textTelefone, 
        textAtendimento, 
        textAtendimentoVendas, 
        textCNPJ, 
        textCreci, 
        textSite, 
        textWhatsappVendas, 
        textWhatsappLocacao, 
        textWhatsappBoletos, 
        
    } from '../store.js';

	// Componentes
    import { Router, Link, link , Route } from "svelte-routing";
    
    // Code
    let links = [
        {
            title: '2ª Via de Boletos e Extratos',
            link: $linkAV,
            target: '_blank',
        },        
        {
            title: 'Documentação para Alugar',
            link: '/documentacao-necessaria',
        },
        {
            title: 'Anuncie seu Imóvel',
            link: '/anuncie',
        },
        {
            title: 'Solicite um Imóvel',
            link: '/solicite-imovel',
        },
        {
            title: 'Solicite Proposta Condomínio',
            link: '/solicite-proposta',
        },
    ];

    let localizacao = [
        {
            title: 'Mapa',
            icon: '<i class="fas fa-map-marked-alt"></i>',
            link: $linkMapa,
        },
        {
            title: 'Waze',
            icon: '<i class="fab fa-waze"></i>',
            link: $linkWaze,
        },
        {
            title: 'Uber',
            icon: '<i class="fab fa-uber"></i>',
            link: $linkUber,
        }
    ];

    let social = [
        {   
            title: 'Facebook',
            link: $linkFacebook,
            icon: '<i class="fab fa-facebook-square"></i>'
        },
        {   
            title: 'Instagram',
            link: $linkInstagram,
            icon: '<i class="fab fa-instagram"></i>'
        },
        {   
            title: 'Twitter',
            link: $linkTwitter,
            icon: '<i class="fab fa-twitter-square"></i>'
        },
    ];    

    let contatos = [
        {
            title: 'Geral <b class="ml-1">' + $textTelefone + '</b>',
            icon: '<i class="fas fa-phone"></i>',
            href: $linkTelefone,
            target: '_blank'
        },
        {
            title: 'Plantão Vendas <b class="ml-1">' + $textWhatsappVendas + '</b>',
            icon: '<i class="fab fa-whatsapp"></i>',
            href: $linkWhatsappVendas,
            target: '_blank'
        },
        {
            title: 'Locação <b class="ml-1">' + $textWhatsappLocacao + '</b>',
            icon: '<i class="fab fa-whatsapp"></i>',
            href: $linkWhatsappLocacao,
            target: '_blank'
        },
        {
            title: '2° Via Boletos <b class="ml-1">' + $textWhatsappBoletos + '</b>',
            icon: '<i class="fab fa-whatsapp"></i>',
            href: $linkWhatsappBoletos,
            target: '_blank'
        }
    ];

    //SOTHEC
    var config = {
        "EmpresaId": 66,            
        "whatsapp": {
            "enable": true,
            "posicao": "right",
            "bottom": "50px"
        },
    };
</script>

<footer>
    <section class="footer-banner">
        <div class="container">
            <div class="footer-banner__box">
                {#each contatos as contato}
                    <a class="footer-banner__item" href="{contato.href}" title="Contato via {contato.title} - {$textSite}" target="_blank">
                        {@html contato.icon} {@html contato.title}
                    </a>
                {/each}
            </div>
        </div>
    </section>
    <section class="informacoes">
        <div class="container">
            <div class="itens text-center">
                <div class="item text-lg-left col-12 col-lg-3">
                    <h2 class="subtitle text-uppercase mb-20"><b>{$textSite}</b></h2>
                    <p class="line-height-large">{$tagsSEO}</p>
                    <ul class="icons-sociais-inline">
                        {#each social as item}
                        <li class="icon">
                            <a href="{item.link}" title="Ir para {item.title} - {$textSite}" target="_blank">
                                {@html item.icon}
                            </a>
                        </li>
                        {/each}
                    </ul>
                </div>
                <div class="item col-12 col-lg-3">
                    <h3 class="subtitle"><i class="fas fa-map-marker-alt"></i> <b>Endereço</b></h3>
                    <ul>
                        <li><p class="mb-0">{@html $textEndereco}</p></li>
                        <ul class="list list--point">
                            {#each localizacao as item}
                            <li class="list-item">
                                <a href="{item.link}" title="Endereço {$textSite} via {item.title}" target="_blank">
                                    {@html item.icon != null ? item.icon : ""} {item.title}
                                </a>
                            </li>
                            {/each}
                        </ul>
                    </ul>        
                </div>
                <div class="item col-12 col-lg-3">
                    <h3 class="subtitle"><i class="fas fa-clock"></i> <b>Atendimento</b></h3>
                    <ul>
                        <li>
                            <p>
                                <b class="text-uppercase"><i class='fas fa-headset mr-5'></i> Geral e Locação</b> <br>
                                {@html $textAtendimento}
                            </p>
                        </li>
                        <li>
                            <p>
                                <b class="text-uppercase"><i class='fas fa-mobile-alt mr-5'></i> Plantão de Vendas</b> <br>
                                {@html $textAtendimentoVendas}
                            </p>                        
                        </li>
                    </ul>
                </div>
                <div class="item d-none d-lg-block text-lg-right col-12 col-lg-3">
                    <h3 class="subtitle"><b>Acesso Rápido</b></h3>
                    <ul>
                        {#each links as item}
                        <li>
                            <a href="{item.link}" use:link replace title="Ir para {item.title}" target="{item.target}">
                                {@html item.icon != null ? item.icon : ""} {item.title}
                            </a>
                        </li>
                        {/each}
                    </ul>
                </div>
            </div>
            <p class="copyright mt-30">© Copyright 2021 - {$textSite} - CRECI {$textCreci} - CNPJ {$textCNPJ} - Todos os Direitos Reservados - Desenvolvido por <a href="{$linkAPI}" target="_blank" title="API - Tecnologia Digital Resultados Reais">API</a></p>
        </div>
    </section>
</footer>